import React, { useEffect, useState, useCallback } from 'react';
import parse from 'html-react-parser';

//Bootstrap
import { Container, Row, Col, Carousel } from 'react-bootstrap';

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faMicrophoneAlt, faVideo, faNewspaper } from '@fortawesome/free-solid-svg-icons';

import './ProductDetail.css'
import ProductRelatedItem from '../ProductRelatedItem/ProductRelatedItem';

const ProductDetail = (props) => {
    // const [fixedTop, setFixedTop] = useState(false);

    // const handleBgTransparent = useCallback(() => {
    //     if (document.documentElement.scrollTop >= 768) {
    //         setFixedTop(true);
    //     } else {
    //         setFixedTop(false);
    //     }
    // }, []);

    // useEffect(() => {
    //     window.addEventListener('scroll', handleBgTransparent, true);
    //     return (() => {
    //         window.removeEventListener('scroll', handleBgTransparent, true);
    //     });
    // }, [handleBgTransparent]);

    const [fixedTop, setFixedTop] = useState(false);
    const [initialPos, setInitialPos] = useState(null);

    const handleFixedTop = useCallback(() => {
        if (document.getElementById("audio")) {
            const initialPosVar = document.getElementById("audio").getBoundingClientRect().top;
            if (document.documentElement.scrollTop === 0) {
                setInitialPos(initialPosVar);
                setFixedTop(false);
                return;
            }
            if (document.documentElement.scrollTop < initialPosVar) {
                setInitialPos(initialPosVar + document.documentElement.scrollTop);
            }
            if (initialPos < document.documentElement.scrollTop + 59) {
                setFixedTop(true);
            } else {
                setFixedTop(false);
            }
        }
    }, [initialPos]);

    useEffect(() => {
        if (document.getElementById("audio")) {
            let initialPosVar = document.getElementById("audio").getBoundingClientRect().top;
            setInitialPos(initialPosVar);
        }
        // setFixedTop(initialPosVar < document.documentElement.scrollTop + 59);
    }, []);

    useEffect(() => {
        if (document.getElementById("audio")) {
            window.addEventListener('scroll', handleFixedTop, true);
            return (() => {
                window.removeEventListener('scroll', handleFixedTop, true);
            });
        }
    }, [handleFixedTop]);

    // if (!props.titlesearch) {
    //     return (
    //         <Container fluid className="p-5 text-center text-white">
    //             <Row>
    //                 <Col>
    //                     <h1 className="font-weight-bolder mb-4 custom-text-black">No pudimos encontrar nada</h1>
    //                     <h3 className="font-weight-lighter custom-text-black-light">Volvé a probar en unos minutos</h3>
    //                 </Col>
    //             </Row>
    //         </Container>
    //     );
    // }
    return (
        <Container fluid className="p-sm-5 p-3 text-center">
            {parseInt(props.TIENE_VIDEO) === 1 ?
                <Row className="p-4 justify-content-center text-align-center">
                    <Col lg="10" xl="7">
                        <div className="embed-responsive embed-responsive-16by9">
                            <iframe title={decodeURIComponent(props.TITULO)} className="embed-responsive-item" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" allowFullScreen></iframe>
                        </div>
                    </Col>
                </Row>
                :
                props.images && props.images.length > 0 ?
                    <Row className="p-4 justify-content-center text-align-center">
                        <Col lg="10" xl="7">
                            <Carousel controls={false} interval={2000}>
                                {props.images.map(i => <Carousel.Item key={i.ID}>
                                    <img src={`../assets/images/${decodeURIComponent(i.SRC_IMAGEN)}`} alt={decodeURIComponent(i.TITULO)} className="img-fluid" />
                                </Carousel.Item>)}
                            </Carousel>
                        </Col>
                    </Row>
                    :
                    null
            }
            <Row className="p-4 justify-content-center text-align-center text-left">
                <Col lg="10" xl="7">
                    <h1 className="custom-text-black custom-font-weight-bolder">{decodeURIComponent(props.TITULO)}</h1>
                    <p className="custom-description-404 mb-2">{`${props.FECHA.substring(8, 10)}/${props.FECHA.substring(5, 7)}/${props.FECHA.substring(0, 4)}`}</p>
                    <p className="mb-3">
                        <span className="badge custom-badge-blue py-1 px-2 text-uppercase custom-max-content custom-float-start">{decodeURIComponent(props.TIPO)}</span>
                        <span className="custom-float-end">
                            {parseInt(props.TIENE_ARTICULO) === 1 ? <FontAwesomeIcon icon={faNewspaper} className="mr-2 custom-icon-title" title="Artículo" />
                                : null}
                            {parseInt(props.TIENE_VIDEO) === 1 ? <FontAwesomeIcon icon={faVideo} className="mr-2 custom-icon-title" title="Video" />
                                : null}
                            {parseInt(props.TIENE_AUDIO) === 1 ? <FontAwesomeIcon icon={faMicrophoneAlt} className="mr-2 custom-icon-title" title="Audio" />
                                : null}
                        </span>
                        <br />
                    </p>
                    <hr className="custom-hr-100" style={{ width: '100%!important' }} />
                </Col>
            </Row>
            {parseInt(props.TIENE_AUDIO) === 1 ?
                <Row className="p-4 justify-content-center align-items-center text-align-center">
                    <Col lg="10" xl="7" className="d-flex justify-content-center align-items-center">
                        {/* <audio src="../../assets/audio/P25E8.mp3" /> */}
                        <div id="audio" name="audio" style={{ width: 'inherit' }} className={fixedTop ? "mx-auto px-md-5 px-0 fixed-top custom-margin-top-audio custom-bg-transparent text-center" : null}>
                            <div style={{ width: 'inherit' }} className={fixedTop ? "mx-auto px-md-4 px-0 custom-bg-transparent" : ""}>
                                <div style={{ width: 'inherit' }} className={fixedTop ? "mx-auto col-lg-10 col-xl-7 custom-color-div-audio d-flex justify-content-center align-items-center" : "d-flex justify-content-center align-items-center"}>
                                    <audio controls controlsList="nodownload" style={{ width: '100%' }}>
                                        <source src={`../assets/audio/${decodeURIComponent(props.SRC_AUDIO)}`} type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                :
                null
            }

            <Row className="p-4 justify-content-center text-align-center text-justify">
                <Col lg="10" xl="7">
                    {parse(decodeURIComponent(props.DESCRIPCION))}
                </Col>
            </Row>
            {props.FULL_ARTICULO ?
                <Row className="p-4 justify-content-center text-align-center text-justify">
                    <Col lg="10" xl="7">
                        {parse(decodeURIComponent(props.FULL_ARTICULO))}
                    </Col>
                </Row>
                :
                null
            }
            <Row className="p-4 justify-content-center text-align-center text-left">
                <Col lg="10" xl="7">
                    {props.LINK_SPOTIFY ?
                        <div className="d-inline">
                            <a href={decodeURIComponent(props.LINK_SPOTIFY)} target="_blank" rel="noopener noreferrer" className="btn custom-btn-green mr-3 my-2">
                                <FontAwesomeIcon icon={faSpotify} className="mr-2" style={{ fontSize: '16px' }} />
                                Ir a Spotify
                            </a>
                        </div>
                        : null}
                    {props.LINK_YOUTUBE ?
                        <div className="d-inline">
                            <a href={decodeURIComponent(props.LINK_YOUTUBE)} target="_blank" rel="noopener noreferrer" className="btn custom-btn-white mr-3 my-2">
                                <FontAwesomeIcon icon={faYoutube} className="mr-2" style={{ fontSize: '16px', color: '#ff0000' }} />
                                Ir a Youtube
                            </a>
                        </div>
                        : null}
                    {props.LINK_INSTAGRAM ?
                        <div className="d-inline">
                            <a href={decodeURIComponent(props.LINK_INSTAGRAM)} target="_blank" rel="noopener noreferrer" className="btn custom-btn-pink mr-3 my-2">
                                <FontAwesomeIcon icon={faInstagram} className="mr-2" style={{ fontSize: '16px' }} />
                                Ir a Instagram
                            </a>
                        </div>
                        : null}
                </Col>
            </Row>
            {props.relatedPosts && props.relatedPosts.length > 0 ?
                <Row className="p-4 justify-content-center text-align-center text-left">
                    <Col lg="10" xl="7">
                        <h5 className="custom-text-black custom-font-weight-bolder">Posts Relacionados</h5>
                        <Row className="justify-content-start">
                            {props.relatedPosts.map(i => <ProductRelatedItem key={i.ID} {...i} />)}
                        </Row>
                    </Col>
                </Row>
                :
                null
            }
        </Container >
    );
};

export default ProductDetail;